import EntityImageActions from '../../entityImage/EntityImageActions';

const RegionImageActions = () => <EntityImageActions entityType="region" />;

export default RegionImageActions;
